import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const HIGHLIGHT_ROW_CLASS = 'ag-row-command-highlight';

const ORDER_TABLES = { elab_order: 'lab_order' };

const tableOf = (type) => ORDER_TABLES[type] || type;

const sameType = (data, highlight) =>
  !highlight.type ||
  [data.rawType, data.type].some((type) => tableOf(type) === tableOf(highlight.type));

export const matchesHighlight = (data, highlight) => {
  if (!data || !highlight) return false;
  if (highlight.id != null) {
    return String(data.id) === String(highlight.id) && sameType(data, highlight);
  }
  const match = String(highlight.match ?? '')
    .trim()
    .toLowerCase();
  if (!match) return false;
  return Object.values(data).some(
    (value) => typeof value === 'string' && value.toLowerCase().includes(match)
  );
};

export const highlightRowClassRules = (highlight, rowClassRules) =>
  highlight
    ? {
        ...rowClassRules,
        [HIGHLIGHT_ROW_CLASS]: (params) => matchesHighlight(params?.data, highlight)
      }
    : rowClassRules;

const isPointed = (highlight) => highlight.id != null || !!String(highlight.match ?? '').trim();

export const isHighlightMissing = (highlight, rows) =>
  !!highlight &&
  isPointed(highlight) &&
  Array.isArray(rows) &&
  !rows.some((data) => matchesHighlight(data, highlight));

const useRowHighlight = (rowClassRules, rows) => {
  const highlight = useLocation().state?.highlight || null;
  const rules = useMemo(
    () => highlightRowClassRules(highlight, rowClassRules),
    [highlight, rowClassRules]
  );
  const isMissing = useMemo(() => isHighlightMissing(highlight, rows), [highlight, rows]);
  return { highlight, rowClassRules: rules, isMissing };
};

export default useRowHighlight;
